<template>
  <div id="content">
    <div id="cont"
         class="center">
      <div style="float:right">
        <el-button type="success"
                   icon="el-icon-download"
                   @click="exportData">{{$t('cart.exporte')}}</el-button>
        <el-button type="primary"
                   icon="el-icon-download"
                   @click="mutidelete">{{$t('cart.mutidelete')}}</el-button>
        <!-- <el-button type="primary"
                   icon="el-icon-s-promotion">发送</el-button> -->
      </div>
      <div class="m b10">&nbsp;</div>
      <el-table :data=products
                :key="key"
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55">
        </el-table-column>
        <el-table-column :label="$t('cart.image')"
                         width="250">
          <template slot-scope="scope">
            <img :src="scope.row.image"
                 width="216"
                 height="152"
                 alt="" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('cart.info')"
                         width="380">
          <template slot-scope="scope">
            <p>{{$t('cart.number')}} {{ scope.row.prod_numbers }}</p>
            <p>{{$t('cart.name')}} {{ scope.row.name }}</p>
            <!--         
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">{{ scope.row.prod_numbers }}</el-tag>
          </div>
        <el-popover trigger="hover" placement="top">
          <p>编号: {{ scope.row.prod_numbers }}</p>
          <p>名称: {{ scope.row.name }}</p>
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">{{ scope.row.name }}</el-tag>
          </div>
        </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('cart.price')"
                         width="100">
          <template slot-scope="scope">
            <p>{{ scope.row.prod_price }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cart.count')"
                         header-align="center"
                         width="220">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.procount"
                             @change="handleCountChange($event,scope.row.id)"
                             :min="1"
                             :max="1000000"
                             label="描述文字"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cart.subtotal')"
                         width="100">
          <template slot-scope="scope">
            <p>{{ scope.row.total_price }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cart.operation')">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="danger"
                       @click="handleDelete(scope.$index, scope.row.id)">{{$t('cart.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <table class="table" id="infoTable" cellspacing="0">
		<tbody><tr>
			<td class="infoTitle">样品图片</td>
			<td class="infoTitle">样品信息</td>
			<td class="infoTitle">样品类型</td>
			<td class="infoTitle">操作</td>
		</tr>
			<tr v-for="c in ccontacts" :key="c.id" >
				<td class="tdStyle">{{c.name_en}}</td>
				<td class="tdStyle">{{c.phone_en}}</td>
				<td class="tdStyle"><a :href="'mailto: '+c.email"> {{c.email}}</a></td>
			</tr>
	</tbody>
  </table> -->
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'About',
  data () {
    return {
      products: [],
      selectids: '',
      key: 0
    };
  },
  mounted () {
    if (this.$route.params.id)
      this.id = this.$route.params.id
    // alert(this.$route.params.id);
    // 使用
    const params = {}; // 参数
    fetch.post("/api/ApiBuyInfo/GetProductBuyList", params).then(
      (res) => {
        this.products = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },

  methods: {
    handleCountChange (va, id) {
      const params = { ID: id, procount: va }; // 参数
      fetch.post("/api/ApiBuyInfo/UpdateProductBuy", params).then(
        (res) => {
          this.products = res;
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
    handleDelete (index, id) {
      const params = { ids: id }; // 参数
      fetch.post("/api/ApiBuyInfo/DeleteProductBuy", params).then(
        (res) => {
          delete this.products[index];
          this.key = Math.random()
          // const paramss = {}; // 参数
          // fetch.post("/api/ApiBuyInfo/GetProductBuyList", paramss).then(
          //   (ress) => {
          //     this.products = ress;
          //   },
          //   (error) => {
          //     alert(JSON.stringify(error));
          //   }
          // );
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },

    handleSelectionChange (va) {

      this.selectids = '';
      va.forEach(element => {
        this.selectids += (element.id + ',')
      });
    },
    handleCheckChange (va, current) {
      alert(JSON.stringify(current))

      const params = { ID: current, procount: va }; // 参数
      fetch.post("/api/ApiBuyInfo/UpdateProductBuy", params).then(
        (res) => {
          this.products = res;
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
    exportData () {
      fetch.post("/api/ApiBuyInfo/GetBuyFilePath", { ids: this.selectids }).then(
        (res) => {
          window.open(res.path);
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
    mutidelete () {
      fetch.post("/api/ApiBuyInfo/DeleteProductBuy", { ids: this.selectids }).then(
        (res) => {
          location.reload();
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    }

  }
};
</script>

<style>
#about {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#cont {
  width: 1190px;
  margin: 20px auto auto;
}

#info {
  width: 880px;
  margin-left: 210px;
}
.center {
  width: 1300px;
  margin: 20px auto;
}
.center #infoTable .tdStyle {
  padding: 15px 0px;
  font-size: 14px;
  width: 298px;
  text-align: center;
  border-top: 1px solid #d0d0d0;
  vertical-align: middle;
}
.center #infoTable {
  border: 1px solid #0099cc;
}
.center #infoTable .infoTitle {
  border: none;
  background-color: #0099cc;
  font-size: 14px;
  color: white;
  padding: 0px;
  width: 298px;
  padding: 10px 0px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Cart.vue